import { html } from 'lit';
import { Eye } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-eye')
export class PdsIconEye extends PdsIcon {
  @state()
  icon = Eye;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
